<template>
  <div class="modal-wrapper-inner" @click.self="onBackdropClick">
    <div class="membership-overlay-card" @click.stop>
      <div v-if="loading" class="membership-overlay-loading">
        <ion-spinner name="crescent" />
      </div>

      <h2 v-if="title" class="membership-overlay-title">{{ title }}</h2>
      <p v-if="message" class="membership-overlay-message">{{ message }}</p>

      <template v-if="actionItems.length">
        <div class="membership-overlay-actions membership-overlay-actions--stack">
          <button
            v-for="item in actionItems"
            :key="item.role"
            type="button"
            class="membership-overlay-action"
            :class="{ 'membership-overlay-action--secondary': item.variant === 'secondary' }"
            @click="onAction(item.role)"
          >
            {{ item.label }}
          </button>
        </div>
      </template>
      <template v-else-if="secondaryActionLabel || primaryActionLabel">
        <div
          class="membership-overlay-actions"
          :class="{ 'membership-overlay-actions--dual': secondaryActionLabel && primaryActionLabel }"
        >
          <button
            v-if="secondaryActionLabel"
            type="button"
            class="membership-overlay-action membership-overlay-action--secondary"
            @click="onSecondary"
          >
            {{ secondaryActionLabel }}
          </button>
          <button
            v-if="primaryActionLabel"
            type="button"
            class="membership-overlay-action"
            @click="onPrimary"
          >
            {{ primaryActionLabel }}
          </button>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup>
import { IonSpinner } from '@ionic/vue';

const props = defineProps({
  title: { type: String, default: '' },
  message: { type: String, default: '' },
  primaryActionLabel: { type: String, default: '' },
  secondaryActionLabel: { type: String, default: '' },
  actionItems: {
    type: Array,
    default: () => [],
  },
  loading: { type: Boolean, default: false },
  dismissOnBackdrop: { type: Boolean, default: true },
});

const emit = defineEmits(['primary', 'secondary', 'action', 'backdrop']);

const onPrimary = () => emit('primary');
const onSecondary = () => emit('secondary');
const onAction = (role) => emit('action', role);
const onBackdropClick = () => {
  if (props.dismissOnBackdrop && !props.loading) {
    emit('backdrop');
  }
};
</script>

<style lang="scss" scoped>
.modal-wrapper-inner {
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  padding: 1rem;
}

.membership-overlay-card {
  box-sizing: border-box;
  width: 100%;
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.14);
}

.membership-overlay-loading {
  display: flex;
  justify-content: center;
  padding: 22px 20px 0;

  ion-spinner {
    width: 28px;
    height: 28px;
    color: #3b99fc;
  }
}

.membership-overlay-title {
  margin: 0;
  padding: 22px 20px 10px;
  font-size: 1.05rem;
  font-weight: 700;
  line-height: 1.3;
  text-align: center;
  color: #1a1a1a;
}

.membership-overlay-loading + .membership-overlay-title {
  padding-top: 14px;
}

.membership-overlay-message {
  margin: 0;
  padding: 0 20px 20px;
  font-size: 0.875rem;
  line-height: 1.5;
  text-align: center;
  color: #888;
}

.membership-overlay-actions {
  display: flex;
  border-top: 1px solid #ebebeb;
}

.membership-overlay-action {
  flex: 1;
  display: block;
  width: 100%;
  margin: 0;
  padding: 15px 8px;
  border: none;
  background: transparent;
  color: #3b99fc;
  font-size: 0.95rem;
  font-weight: 500;
  letter-spacing: 0.3px;
  text-align: center;
  cursor: pointer;
}

.membership-overlay-actions--dual .membership-overlay-action:not(:last-child) {
  border-right: 1px solid #ebebeb;
}

.membership-overlay-action--secondary {
  color: #999;
  font-weight: 400;
}

.membership-overlay-actions--stack {
  flex-direction: column;
}

.membership-overlay-actions--stack .membership-overlay-action + .membership-overlay-action {
  border-top: 1px solid #ebebeb;
}
</style>
